"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const partners = ["Global Sourcing", "Clinical Evaluation", "Regulatory Support", "Strategic Distribution", "AI Integration", "Digital Health", "Quality Assurance", "Market Access", "Supply Chain", "Long-term Partnership"];
  const marqueeItems = [...partners, ...partners];
  return;
}